export type GlobalErrorHandler = (error: unknown) => void

let handler: GlobalErrorHandler | null = null

export const setGlobalErrorHandler = (fn: GlobalErrorHandler) => {
  handler = fn
}

export const callGlobalErrorHandler = (error: unknown) => {
  if (handler) {
    handler(error)
  }
}
